
import styled from 'styled-components'

const FormHelper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 32px;
    padding-top: 16px;

    border-top: 1px solid var(--light-gray4);
`;

export default FormHelper;